"use strict";
// @ts-ignore
try {
    self['workbox:window:7.0.0'] && _();
}
catch (e) { }
